import { Validators } from '@biteinc/common';
import { allEnumValues, ItemTaxationStatusHelper, MenuItemSaleUnit } from '@biteinc/enums';
/**
 * Schema for the ordered item price option as it appears in the database.
 * Note that this schema differs from the request schema.
 */
export const orderedPriceOptionDbSchema = {
    displayName: 'ordered price option db',
    type: 'object',
    fields: {
        _id: {
            type: 'mongoId',
            required: true,
            isPermanent: true,
        },
        i9nId: {
            type: 'keyString',
            isPermanent: true,
        },
        posId: {
            type: 'keyString',
            isPermanent: true,
        },
        name: {
            type: 'shortString',
            isPermanent: true,
        },
        fulfillmentName: {
            type: 'shortString',
        },
        price: {
            type: 'price',
            canBeNegative: true,
            required: true,
            isPermanent: true,
        },
        originalPrice: {
            type: 'price',
            canBeNegative: true,
            isPermanent: true,
        },
        originalUnitPrice: {
            type: 'price',
            canBeNegative: true,
            isPermanent: true,
        },
        quantity: {
            type: 'int',
            min: 1,
            required: true,
            isPermanent: true,
        },
        saleUnit: {
            type: 'int',
            values: allEnumValues(MenuItemSaleUnit),
            isPermanent: true,
        },
        weight: {
            type: 'float',
            min: 0,
            isPermanent: true,
        },
        unitPrice: {
            type: 'price',
            canBeNegative: true,
            required: true,
        },
        barcode: {
            type: 'keyString',
            validationRegex: Validators.barcodeRegexString,
            isPermanent: true,
        },
        addonSets: {
            type: 'array',
            elementType: 'object',
            fields: {
                _id: {
                    type: 'mongoId',
                    required: true,
                    isPermanent: true,
                },
                posId: {
                    type: 'keyString',
                    isPermanent: true,
                },
                i9nId: {
                    type: 'keyString',
                    isPermanent: true,
                },
                posFields: {
                    type: 'object',
                    isFreeform: true,
                },
                parentModGroupId: {
                    type: 'mongoId',
                },
                name: {
                    type: 'shortString',
                    required: true,
                    isPermanent: true,
                },
                fulfillmentName: {
                    type: 'shortString',
                    isPermanent: true,
                },
                isSizeGroup: {
                    type: 'bool',
                    isPermanent: true,
                },
                isComboDecision: {
                    type: 'bool',
                    isPermanent: true,
                },
                isRequiredSingularAndShouldBeReplacedByChildren: {
                    type: 'bool',
                    isPermanent: true,
                },
                originalId: {
                    type: 'mongoId',
                    isPermanent: true,
                },
                items: {
                    type: 'array',
                    elementType: 'object',
                    fields: {
                        _id: {
                            type: 'mongoId',
                            required: true,
                            isPermanent: true,
                        },
                        orderedItemId: {
                            type: 'mongoId',
                            isPermanent: true,
                        },
                        posId: {
                            type: 'keyString',
                            isPermanent: true,
                        },
                        i9nId: {
                            type: 'keyString',
                            isPermanent: true,
                        },
                        name: {
                            type: 'shortString',
                            required: true,
                            isPermanent: true,
                        },
                        fulfillmentName: {
                            type: 'shortString',
                            isPermanent: true,
                        },
                        posName: {
                            type: 'shortString',
                            isPermanent: true,
                        },
                        instructions: {
                            type: 'shortString',
                            isPermanent: true,
                        },
                        posFields: {
                            type: 'object',
                            isFreeform: true,
                        },
                        taxationStatus: {
                            type: 'int',
                            values: ItemTaxationStatusHelper.allValuesForMods(),
                            isPermanent: true,
                        },
                        prepTimeMinutes: {
                            type: 'int',
                            min: 0,
                            max: 1440,
                            isPermanent: true,
                        },
                        textFields: {
                            type: 'array',
                            elementType: 'object',
                            fields: {
                                i9nId: {
                                    type: 'keyString',
                                    required: true,
                                },
                                label: {
                                    type: 'shortString',
                                },
                                text: {
                                    type: 'shortString',
                                    required: true,
                                },
                            },
                        },
                        substitutionFor: {
                            type: 'object',
                            fields: {
                                modId: {
                                    type: 'mongoId',
                                },
                                substitutionModGroupId: {
                                    type: 'mongoId',
                                },
                            },
                        },
                        priceOption: {
                            type: 'object',
                            subtype: 'OrderedPriceOptionDb',
                            required: true,
                        },
                        upsellScreen: {
                            type: 'shortString',
                        },
                        upsellTotal: {
                            type: 'price',
                        },
                        price: {
                            type: 'price',
                        },
                    },
                },
                deselectedItems: {
                    type: 'array',
                    elementType: 'object',
                    fields: {
                        _id: {
                            type: 'mongoId',
                            required: true,
                            isPermanent: true,
                        },
                        orderedItemId: {
                            type: 'mongoId',
                            isPermanent: true,
                        },
                        posId: {
                            type: 'keyString',
                            isPermanent: true,
                        },
                        i9nId: {
                            type: 'keyString',
                            isPermanent: true,
                        },
                        name: {
                            type: 'shortString',
                            required: true,
                            isPermanent: true,
                        },
                        posName: {
                            type: 'shortString',
                            isPermanent: true,
                        },
                        posFields: {
                            type: 'object',
                            isFreeform: true,
                        },
                        taxationStatus: {
                            type: 'int',
                            values: ItemTaxationStatusHelper.allValuesForMods(),
                            isPermanent: true,
                        },
                        prepTimeMinutes: {
                            type: 'int',
                            min: 0,
                            max: 1440,
                            isPermanent: true,
                        },
                        priceOption: {
                            type: 'object',
                            subtype: 'OrderedPriceOptionDb',
                            required: true,
                        },
                    },
                },
            },
        },
    },
};
//# sourceMappingURL=ordered_price_option_db_schema.js.map